import { render, staticRenderFns } from "./Dotations.vue?vue&type=template&id=9da36238&scoped=true&"
import script from "./Dotations.vue?vue&type=script&lang=ts&"
export * from "./Dotations.vue?vue&type=script&lang=ts&"
import style0 from "./Dotations.vue?vue&type=style&index=0&id=9da36238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da36238",
  null
  
)

export default component.exports